import {Injectable} from '@angular/core';
import {CanActivate, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {initJournal} from '../_actions/journal.actions';
import {selectInitJournal} from '../_selectors/journal.selectors';
import {mapTo, skipWhile, withLatestFrom} from 'rxjs/operators';
import * as fromUser from '../../../../src/app/_selectors/user.selectors';

@Injectable({
	providedIn: 'root'
})
export class JournalInitGuard implements CanActivate {
	constructor(private store: Store) {}
	canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		this.store.dispatch(initJournal());
		return this.store.select(selectInitJournal).pipe(
			withLatestFrom(this.store.select(fromUser.selectLogout)),
			skipWhile(([init, logout]) => !init || logout),
			mapTo(true)
		);
	}
}
